<div [ngClass]="formatter">
  <label
    class="bl-label bl-font-weight--800 bl-font-size--14"
    [for]="field.id"
    [id]="field.id + '-label'"
    [class.bl-required]="field.required">
    {{ field.label }}
    <ng-container *ngIf="field.config.tooltip">
      <button type="button" aria-label="tooltip" attr.aria-describedby="tooltip-info-{{field.id}}" class="bl-font-color--blue bl-margin-left--4">
        <i class="cu-info-circle" eaTooltip="{{ field.config.tooltip }}"></i>
      </button>
      <span id="tooltip-info-{{field.id}}"  class="bl-screen-reader-only">{{field.config.tooltip}}</span>
    </ng-container>
  </label>
  <div class="bl-position--relative"> 
    <input 
    class="bl-input"
    type="text" 
    [attr.aria-describedby]="field.id+'-desc-container'"
    [attr.aria-labelledby]="fieldLabelledBy"
    [attr.data-automation-id]="field.automationId"
    [(ngModel)]="maskData"
    [patterns]="pattern"
    [hiddenInput]="hidden" 
    [mask]="field.id.indexOf('ssn') !== -1 ? '000-00-0000' : '00-0000000'"
    #input
    [attr.inputmode]="field.inputMode"
    [cuFieldState]="field"
    [disabled]="!field.enabled"
    [id]="field.id"
    [placeholder]="field.config.placeholder || ''"
    (blur)="maskSecurityIdentity()">
    <button type="button" (click)="unhide()" class="bl-input-append input-eye-icon password-visibility" id="reveal-password">
      <i [ngClass]="!hidden ? 'cu-eye-slash' : 'cu-eye'"></i>
      <span class="bl-screen-reader-only">
        {{'cuLogin/revealPassword' | dictionary}}
      </span>
    </button>
  </div>
</div>